import type { IconName } from "@/components/ui/icons";

/** Compact glyph for the current computer action, beside its text. */
export function workToastActionIcon(key: string): IconName {
  switch (key) {
    case "click": return "MousePointerClick";
    case "drag": return "Hand";
    case "scroll-up": return "ArrowUp";
    case "scroll-down": return "ArrowDown";
    case "scroll-left": return "ArrowLeft";
    case "scroll-right": return "ArrowRight";
    case "copy": return "Copy";
    case "paste": return "ClipboardPaste";
    case "typing": return "Keyboard";
    case "screenshot": return "Camera";
    case "look": return "Eye";
    default: return "Zap";
  }
}
